import { useEffect } from "react";
import { useAppBranding } from "@/contexts/app-branding";

export function usePageTitle(pageTitle?: string) {
  const { appName } = useAppBranding();

  useEffect(() => {
    if (pageTitle) {
      document.title = `${pageTitle} | ${appName}`;
    } else {
      document.title = appName;
    }
  }, [pageTitle, appName]);
}
